import React, { useState } from 'react';
import {
  Button, Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Prompt from '../layout/Prompt';

type Props = {
  groundTruthId?: number;
  onReset: (dgtId: number) => void;
};

const GTResetButton = ({ groundTruthId, onReset }: Props) => {
  const [showWarning, setShowWarning] = useState<boolean>(false);

  const promptAction = (confirm: boolean) => {
    if (confirm && groundTruthId !== undefined) {
      onReset(groundTruthId);
    }
    setShowWarning(false);
  };

  return (
    <>
      <Button
        disabled={!groundTruthId}
        color="warning"
        onClick={() => setShowWarning(true)}
      >
        <FormattedMessage id="genericDelete" />
      </Button>
      {showWarning && groundTruthId && (
        <Prompt
          title={<FormattedMessage id="groundtruth.title" />}
          display={showWarning}
          action={promptAction}
          version={2}
        >
          <Typography><FormattedMessage id="groundtruth.message" /></Typography>
        </Prompt>
      )}
    </>
  );
};

export default GTResetButton;
